<div class="mt-5">
  <div class="header">
    <div class="row" style="margin-right: 0px !important">
      <div class="col-md">
        <h3>จำนวนครั้งการส่ง SMS (รายเดือน)</h3>
      </div>

      <div class="row" style="margin-right: 0px !important">
        <button type="button" class="btn btn-dv btn-wide mr-3" (click)="downloadSMSReport()">
          <i *ngIf="downloading" class="fa fa-spinner fa-spin m-r-5"></i>
          ดาวน์โหลดรายงาน
        </button>

        <div class="company-dropdown">
          <p-dropdown class="dv-dropdown" selectId="company" [options]="company" [(ngModel)]="selectedCompany"
            [autoDisplayFirst]="false" placeholder="บริษัท" (onChange)="loadMonthlyDatasms()">
          </p-dropdown>
        </div>

        <div class="year-dropdown">
          <p-dropdown class="dv-dropdown" selectId="years" [options]="yearList" [(ngModel)]="selectedYear"
            [autoDisplayFirst]="false" placeholder="ปี" (onChange)="loadMonthlyDatasms()">
          </p-dropdown>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="box-parent scrollable" style="height: calc(100vh - 2.25rem - 150px);">
  <canvas id="sms-counter-bar-chart">{{ charts_sms_counter_bar_stackeds }}</canvas>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-sms/dashboard-sms.component.html